import { forwardRef, type Ref, type SVGProps } from "react";

function SvgTrendingUp(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 55 31" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={5}
        d="M36.8 2.893h15.022m0 0v15.022m0-15.022L30.541 24.174 18.648 12.282 3 27.93"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTrendingUp);
export default ForwardRef;
